// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"9775e5de","453":"225c7bce"}[chunkId] + ".chunk.js";
};